<template>
  <el-breadcrumb separator="/" class="pageBreadcrumb">
    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
    <template v-for="item in links">
      <el-breadcrumb-item v-if="item.path == ''" :key="item.title">{{ item.title }}</el-breadcrumb-item>

      <el-breadcrumb-item v-if="item.path != ''" :to="item.path" :key="item.title">{{ item.title }}</el-breadcrumb-item>
    </template>
  </el-breadcrumb>
</template>
<script>
export default {
  name: "PageHeader",
  props: {
    links: {
      type: Array,
    },
  },
}
</script>
<style scoped>
.pageBreadcrumb {
  border-bottom: 1px solid #e2e2e2;
}
.pageContainer {
  height: calc(100% - 46px);
  display: flex;
  flex-direction: row;
}
</style>
